export const getEnvironment = (currentHost) => {
    const devEnvRegex =
        /(proj\d+)|(uat\d+)|(uat\.)|(cte\d+)|(cdemo\d+)|(aws\.gwl\.com)|(^uat)|(qa)|(localhost)|(evaluate\d+)/i; // if domain is proj[0-n] or uat[0-n] or cte[0-n] or cdemo[0-n] aws.gwl.com case insensitive
    return devEnvRegex.test(currentHost);
};
